import { JSONable } from '@irian-ro/abstract-resource';
import { ShipmentStatusChangeDtoModel } from '@well/domain';
import { PackageResumeModel, PackageTypeSummary } from '@well/delivery-libs/packages/domain';

export class ShipmentTrackingVoModel extends JSONable {
  uuid!: string;
  owner!: string;
  deleted = false;

  orderUuid: string | null = null;
  orderNumber: string | null = null;
  serviceProviderName: string | null = null;
  costCenter: string | null = null;
  externalReference: string | null = null;
  pinned = false;
  series: string | null = null;

  pickupAddressLine: string | null = null;
  pickupCompany: string | null = null;
  pickupCity: string | null = null;
  pickupCountry: string | null = null;
  pickupWindowStart: string | null = null;
  pickupWindowEnd: string | null = null;
  pickupTimezone: string | null = null;
  pickupDeadline: string | null = null;
  pickupNamedLocationLabel: string | null = null;
  pickupNamedLocationCode: string | null = null;

  deliveryAddressLine: string | null = null;
  deliveryCompany: string | null = null;
  deliveryCity: string | null = null;
  deliveryCountry: string | null = null;
  deliveryWindowStart: string | null = null;
  deliveryWindowEnd: string | null = null;
  deliveryTimezone: string | null = null;
  deliveryNamedLocationLabel: string | null = null;
  deliveryNamedLocationCode: string | null = null;

  currentStatus: string | null = null;

  shipmentStatusChangeDTOS: ShipmentStatusChangeDtoModel[] = [];

  packageResumeView: PackageResumeModel | null = null;

  packageSummary: PackageTypeSummary[] = [];
}
